/** Format a numeric price as a currency string (matches the template style). */
export const formatPrice = (value: number): string => `$${value.toFixed(2)}`
